import React from 'react';
import { Route, Redirect, Switch, HashRouter } from 'react-router-dom';
import loadable from 'react-loadable';
import LoadingComponent from 'components/Loading';
import decode from "jwt-decode";
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// 3rd
import 'styles/antd.less';
import 'styles/bootstrap/bootstrap.scss'
// custom
import "styles/layout.scss"
import "styles/theme.scss"
import "styles/ui.scss"
import "styles/vendors.scss"
import Login from '../routes/form/routes/forms/components/LoginForm2';
import ForgotComponent from '../routes/user/routes/ForgotPassword';
import SetPassword from '../routes/user/routes/setPassword';


let AsyncAppLayout = loadable({
  loader: () => import('components/Layout/AppLayout/'),
  loading: LoadingComponent
})
let AsyncException = loadable({
  loader: () => import('routes/exception/'),
  loading: LoadingComponent
})

const checkAuth = () => {
  const token = localStorage.getItem("token");
  // debugger;
  if (!token) {
    // logout();
    return false;
  }
  try {
    const { exp } = decode(token);
    // console.log(exp)
    const date = Date.now().valueOf() / 1000;
    if (date > exp) {
      localStorage.removeItem("token");
      // logout();
      return false;
    } else {
      return true;
    }
  } catch (err) {
    return false;
  }
};

const LoginRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      checkAuth() ? <Redirect to="/app/dashboard" /> : <Component {...props} />
    }
  />
);
const Authorization = ({
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        checkAuth() ? (<Component {...props} />) : (
          <Redirect to="/user/login" />
        )
      }
    />
  );
};


class App extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      user: null,
      isLoggedIn: false,
      status: ""
    }
  }

  // onUnload = e => { // the method that will be used for both add and remove event
  //   e.preventDefault();
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("currentUser");
  //   localStorage.removeItem("role");
  //   localStorage.removeItem("status");
  //   this.setState({
  //     isLoggedIn: false,
  //   });
  //   e.returnValue = '';
  // }


  componentDidMount() {
    checkAuth()
      ? this.setState({ isLoggedIn: true })
      : this.setState({ isLoggedIn: false });
      // window.addEventListener("beforeunload", this.onUnload);

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isLoggedIn !== this.props.isLoggedIn) {
      this.setState({
        isLoggedIn: this.props.isLoggedIn === "" ? false : true
      })
    }
  }

  componentWillUnmount() {
    // window.removeEventListener("beforeunload", this.onUnload);
  }

  render() {
    const { match, location } = this.props;
    const isRoot = location.pathname === '/' ? true : false;
    if (isRoot) {
      return (<Redirect to={`${match.url}user/login`} />);
    }
    return (
      <div id="app">
        <ToastContainer />
        <HashRouter>
          <React.Suspense>
            <Switch>
              <Authorization path={`${match.url}app`}
                component={(props) => (
                  <div>
                    <AsyncAppLayout
                      isLoggedIn={this.state.isLoggedIn}
                      logdedInHandler={(isLoggedIn) => this.setState({ isLoggedIn })}
                      {...props}
                    />
                  </div>
                )}
              />
              <Route path={`${match.url}exception`} component={AsyncException} />
              <LoginRoute
                exact
                path={`${match.url}user/login`}
                name="Login Page"

                component={(props) => (
                  <div>
                    <Login
                      userHandler={(user, isLoggedIn) =>
                        this.setState({ user, isLoggedIn })
                      }
                      {...props}
                    />
                  </div>
                )}
              />
              <Route
                exact
                path={`${match.url}user/forgot-password`}
                component={ForgotComponent}
              />

              <Route
                exact
                path={`${match.url}user/setPassword/:code`}
                component={SetPassword}
              />
              {/* <Route path={`${match.url}user`} component={AsyncAccount} /> */}
            </Switch>
          </React.Suspense>
        </HashRouter>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return ({
    isLoggedIn: state.settings.isLoggedIn,
    user: state.settings.userDetail
  })
};

export default connect(mapStateToProps)(App);
